import axios from './config/axios'

const postValidatePin = (pin, lastName) => {
  return axios
    .post('/api/members/validate', {
      pin: pin,
      lastName: lastName
    })
    .then(r => r.data)
}
export default postValidatePin